import React, {useEffect, useRef, useState} from "react";
import "./Language.css";
import useLocalStorage from '../../hooks/use-localstorage';
import i18n from '../../texts/i18n';

import { ReactComponent as ArrowUp } from '../../icons/arrowup.svg';
import { ReactComponent as ArrowDown } from '../../icons/arrowdown.svg';

export const Language = () => {
    const [language, setLanguage] = useLocalStorage('language', 'ru');
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const isInternationalVersion = i18n.options.fallbackLng.length === 1;


    const handleLenguageChangeToEN = () => {
        i18n.changeLanguage('en');
        setLanguage('en');
        setIsOpen(false);
    };

    const handleLenguageChangeToRU = () => {
        i18n.changeLanguage('ru');
        setLanguage('ru');
        setIsOpen(false);
    };

    const toggleDropdown = () => {
        setIsOpen((prev) => !prev);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        !isInternationalVersion ?
            (
                <div className="languageDropdown" ref={dropdownRef}>
                    <div className="languageSelected" onClick={toggleDropdown}>
                        {language.toUpperCase()}
                        {isOpen ? <ArrowUp /> : <ArrowDown />}
                    </div>
                    {isOpen && (
                        <div className="languageOptions">
                            <div
                                className={`languageOption ${language === "en" ? "active" : ""}`}
                                onClick={() => handleLenguageChangeToEN()}
                            >
                                EN
                            </div>
                            <div
                                className={`languageOption ${language === "ru" ? "active" : ""}`}
                                onClick={() => handleLenguageChangeToRU()}
                            >
                                RU
                            </div>
                        </div>
                    )}
                </div>
            )
            : <></>
    );
};